import { MedicalServiceNameForReceiptType } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { RadioGroupItem } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../../../translations';

export const getReceiptTypes = (): RadioGroupItem<MedicalServiceNameForReceiptType>[] => {
   return [
      {
         id: 'SAME_AS_STANDARD',
         label: medicalServiceTranslationKeys.shared.nameForReceiptType.SAME_AS_STANDARD,
      },
      {
         id: 'SAME_AS_FOR_INVOICING',
         label: medicalServiceTranslationKeys.shared.nameForReceiptType.SAME_AS_FOR_INVOICING,
      },
      {
         id: 'OTHER',
         label: medicalServiceTranslationKeys.shared.nameForReceiptType.OTHER,
      },
   ];
};
